module.exports = __webpack_public_path__ + "media/components/brandings/svgs/email/branding-email-buttontext-11415700ff0bd6aa5e7659f97a995aab.svg";